export default () => {
    let statusModule = document.querySelectorAll('.js-statusModule');

    if (!statusModule.length)
        return;

    statusModule.forEach(function (item) {
        let svgs = item.querySelectorAll('svg');

        svgs.forEach(function (svg, index) {
            let width = svg.getAttribute('width');
            let height = svg.getAttribute('height');
            let viewBox = svg.getAttribute('viewBox');

            if (!viewBox) {
                if (!width)
                    width = svg.getClientRects()[0].width;

                if (!height)
                    height = svg.getClientRects()[0].height;

                svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
            }
        });
    });
};